import { getAccessToken } from '../../http/auth-storage';
import { notifyTenantChanged } from './tenant-change';

// A cada 250ms por até 15s: o refresh de token é uma chamada de rede delegada ao
// Angular; esse intervalo detecta a troca sem pesar no event loop.
const POLL_INTERVAL_MS = 250;
const POLL_TIMEOUT_MS = 15_000;

let switching = false;

/** Verdadeiro enquanto uma troca/saída de conta está pendente do refresh de token. */
export function isSwitchingAccount(): boolean {
  return switching;
}

/**
 * Marca o início de uma troca/saída de conta e avisa os inscritos. A sidebar usa
 * isso para exibir um estado de carregamento em vez de montar o menu com o estado
 * em transição (tenant novo + permissões do token antigo), evitando o "piscar" de
 * itens misturados até o token da conta chegar.
 */
export function beginAccountSwitch(): void {
  switching = true;
  notifyTenantChanged();
}

/**
 * Observa o token (reescrito de forma assíncrona pelo Angular na troca/saída de
 * conta) e encerra a transição quando ele muda, re-notificando para a sidebar
 * montar o menu já com as permissões definitivas. Limitado por timeout: refresh
 * que falha encerra a transição mesmo assim, para a UI não ficar presa carregando.
 *
 * `onTokenRefreshed` roda uma única vez, depois da notificação, e só quando o token
 * mudou. Apenas a mudança de token prova que a troca concluiu: no timeout o refresh
 * pode não ter acontecido, e o storage ainda refletiria a conta anterior.
 */
export function endAccountSwitchOnTokenRefresh(
  previousToken: string | null,
  onTokenRefreshed?: () => void,
): void {
  const start = Date.now();

  const timer = setInterval(() => {
    const tokenChanged = getAccessToken() !== previousToken;
    const timedOut = Date.now() - start >= POLL_TIMEOUT_MS;

    if (tokenChanged || timedOut) {
      clearInterval(timer);
      switching = false;
      notifyTenantChanged();
      if (tokenChanged) {
        onTokenRefreshed?.();
      }
    }
  }, POLL_INTERVAL_MS);
}
